import { Typography } from 'antd';
import styled from 'styled-components';

export const ParagraphNoBottom = styled(Typography.Paragraph)`
  margin-bottom: 0 !important;
`;
